module.exports = "/_next/static/images/bank-account-414c65a5593b6ede6dc47b1c8e15899d.svg";